import proj4 from "proj4";
import wellknown from "wellknown";

proj4.defs(
  "EPSG:28992",
  "+title=Amersfoort / RD New +proj=sterea +lat_0=52.15616055555555 +lon_0=5.38763888888889 +k=0.999908  +x_0=155000 +y_0=463000 +ellps=bessel +units=m +towgs84=565.2369,50.0087,465.658,-0.406857330322398,0.350732676542563,-1.8703473836068,4.0812 +no_defs"
);
export { proj4 };

export type GPS = [number, number];
export const toXY = (gps: GPS) => gps && (proj4("EPSG:28992").forward(gps) as GPS);
export const emptyFeatureCollection: GeoJSON.FeatureCollection<GeoJSON.Geometry> = {
  type: "FeatureCollection",
  features: [],
};

// Shoelace formula on a single ring of [x, y] coordinates in meters.
const ringArea = (ring: number[][]) => {
  let sum = 0;
  for (let i = 0, n = ring.length; i < n; i++) {
    const [x1, y1] = ring[i];
    const [x2, y2] = ring[(i + 1) % n];
    sum += x1 * y2 - x2 * y1;
  }
  return Math.abs(sum) / 2;
};

// Area in square meters. Accepts a WKT string or a GeoJSON geometry.
// Coordinates are assumed to be lon/lat (EPSG:4326) and are transformed to
// EPSG:28992 (RD New, metric) before the area is calculated.
export const calculateArea = (p): number => {
  if (!p) return 0;
  let geom = typeof p === "string" ? wellknown.parse(p) : p;
  // Unwrap a GeoJSON Feature to its geometry.
  if (geom && geom.type === "Feature") geom = geom.geometry;
  if (!geom) return 0;

  const proj = proj4("EPSG:28992");
  const polygonArea = (polygon: number[][][]) =>
    polygon.reduce((acc, ring, i) => {
      const area = ringArea(ring.map((c) => proj.forward(c) as number[]));
      // First ring is the exterior, subsequent rings are holes.
      return i === 0 ? acc + area : acc - area;
    }, 0);

  if (geom.type === "Polygon") {
    return polygonArea(geom.coordinates as number[][][]);
  }
  if (geom.type === "MultiPolygon") {
    return (geom.coordinates as number[][][][]).reduce((acc, poly) => acc + polygonArea(poly), 0);
  }
  return 0;
};
